import { Link } from "react-router-dom";
import { Instagram, Heart, Lock } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function Footer() {
  const { settings } = useSettings();
  return (
    <footer className="mt-20 border-t-[3px] border-ink bg-ink text-cream" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 py-12 grid gap-8 md:grid-cols-3">
        <div>
          <h3 className="font-display text-2xl mb-2">{settings?.shop_name || "Caricatures"}</h3>
          <p className="text-cream/70 text-sm max-w-xs">{settings?.tagline}</p>
          <p className="text-cream/60 text-xs mt-3 max-w-xs" data-testid="footer-local-seo">Custom caricature artist serving <strong className="text-cream/80">Grand Forks</strong> &amp; <strong className="text-cream/80">Fargo, North Dakota</strong> — plus commissions worldwide.</p>
        </div>
        <div className="flex flex-col gap-2 font-display">
          <span className="text-sun font-bold mb-1">Explore</span>
          <Link to="/gallery" className="text-cream/80 hover:text-sky">Examples</Link>
          <Link to="/process" className="text-cream/80 hover:text-sky">How It's Made</Link>
          <Link to="/events" className="text-cream/80 hover:text-sky">Events</Link>
          <Link to="/testimonials" className="text-cream/80 hover:text-sky">Reviews</Link>
          <Link to="/order" className="text-cream/80 hover:text-sky">Order Now</Link>
        </div>
        <div className="flex flex-col gap-3">
          <span className="text-sun font-bold font-display">Say hi</span>
          {settings?.instagram_url && (
            <a href={settings.instagram_url} target="_blank" rel="noreferrer" data-testid="footer-instagram"
              className="inline-flex items-center gap-2 text-cream/80 hover:text-bubble">
              <Instagram className="w-5 h-5" /> Instagram
            </a>
          )}
          {settings?.contact_email && (
            <a href={`mailto:${settings.contact_email}`} data-testid="footer-email"
              className="text-cream/80 hover:text-sky text-sm underline underline-offset-2">
              {settings.contact_email}
            </a>
          )}
        </div>
      </div>
      <div className="border-t border-cream/20 py-4 text-center text-cream/50 text-xs flex flex-col sm:flex-row items-center justify-center gap-2">
        <span className="flex items-center gap-1">Made with <Heart className="w-3 h-3 text-bubble fill-bubble" /> · {new Date().getFullYear()}</span>
        <span className="hidden sm:inline">·</span>
        <Link to="/admin/login" data-testid="footer-owner-login" className="inline-flex items-center gap-1 text-cream/50 hover:text-sun">
          <Lock className="w-3 h-3" /> Owner login
        </Link>
      </div>
    </footer>
  );
}
